import { EnhancedWatchlist } from '../../hooks/use-watchlist/types'

export default function isWatchlistEditable(watchlist: EnhancedWatchlist) {
  return watchlist.type !== 'auto'
}
